var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsCounterClockwise = function SvgIconArrowsCounterClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46 3.456a9.24 9.24 0 0 1 10.08 2.006 1 1 0 0 1-1.416 1.413 7.24 7.24 0 0 0-10.247 0l-.002.002-1.474 1.47h2.08a1 1 0 0 1 0 2h-4.5a1 1 0 0 1-1-1v-4.5a1 1 0 1 1 2 0v2.09l1.48-1.475h.001a9.2 9.2 0 0 1 2.999-2.006M15.519 14.653a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0v-2.09l-1.48 1.475a9.245 9.245 0 0 1-10.078 2.006 9.2 9.2 0 0 1-3-2.006 1 1 0 0 1 1.416-1.413 7.24 7.24 0 0 0 10.247 0l.001-.002 1.475-1.47h-2.081a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconArrowsCounterClockwise;